import { Currency } from '@/core/currency/interfaces';

const MNT: Currency = {
    name: 'Mongolian Tögrög',
    demonym: 'Mongolian',
    majorSingle: 'Tögrög',
    majorPlural: 'Tögrög',
    codeNumeric: '496',
    symbol: '₮',
    symbolNative: '₮',
    minorSingle: 'möngö',
    minorPlural: 'möngö',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MNT',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MNT;
